var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["loyalty/templates/loyalty-birthday-month.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<div class=\"g-loyalty-form__field-birthday-month\">\n\n    <div class=\"c-form__field c-loyalty__birthday-month-field ";
output += runtime.suppressValue((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"first")?"is-required":""), env.opts.autoescape);
output += " ";
output += runtime.suppressValue((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"loyaltyForm")?(lineno = 2, colno = 102, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "hasErrors"), "hasErrors", context, [runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"loyaltyForm")),"errors")),"messages")),"dateOfBirthMonth")])):""), env.opts.autoescape);
output += "\">\n\n        <label for=\"loyalty-birthday-month\" class=\"u-off-screen-hidden\">\n            ";
output += runtime.suppressValue((lineno = 5, colno = 14, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["loyalty_birthday-label-month"])), env.opts.autoescape);
output += "\n        </label>\n\n        <select ";
output += runtime.suppressValue((lineno = 8, colno = 32, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "validatedSelect"), "validatedSelect", context, ["ERROR_CORE_REQUIRED_FIELD_ERROR",runtime.makeKeywordArgs({"field": (lineno = 8, colno = 78, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["core.loyaltyForm.errors.messages.dateOfBirthMonth"]))})])), env.opts.autoescape);
output += "\n            id=\"loyalty-birthday-month\"\n            name=\"dateOfBirthMonth\"\n            class=\"c-form__select c-loyalty__birthday-select\"\n            data-qa-loyalty-signup-birthday-month\n            aria-describedby=\"loyalty-birthday-month_error\">\n\n            <option value=\"\" disabled selected hidden>\n            ";
output += runtime.suppressValue((lineno = 16, colno = 14, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["loyalty_month-option"])), env.opts.autoescape);
output += ":\n            </option>\n\n            ";
output += runtime.suppressValue((lineno = 19, colno = 25, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "monthOptions"), "monthOptions", context, [env.getFilter("default").call(context, runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"loyaltyForm")),"data")),"birthdayData")),"birthMonth"))])), env.opts.autoescape);
output += "\n\n        </select>\n\n            ";
output += runtime.suppressValue((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"loyaltyForm")?(lineno = 23, colno = 31, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "displayFieldErrors"), "displayFieldErrors", context, [runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"loyaltyForm")),"errors")),"messages")),"dateOfBirthMonth"),runtime.makeKeywordArgs({"id": "loyalty-birthday-month"})])):""), env.opts.autoescape);
output += "\n    </div>\n\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["loyalty/templates/loyalty-birthday-month.j2"] , dependencies)